import { render, staticRenderFns } from "./Setsex.vue?vue&type=template&id=19cb9bab&scoped=true"
import script from "./Setsex.vue?vue&type=script&lang=js"
export * from "./Setsex.vue?vue&type=script&lang=js"
import style0 from "./Setsex.vue?vue&type=style&index=0&id=19cb9bab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cb9bab",
  null
  
)

export default component.exports